import {Component, React, observer} from '$src/handy'
import * as css from './EditLocationModal.css'
import GenericModal from '$src/common/GenericModal'
import {Form} from '$src/common/forms'
import TextInput from '$src/common/TextInput'
import GenericButton from '$src/common/GenericButton'
import {getSnapshot} from 'mobx-state-tree'
import editHousingCorporationName from '$src/api/endpoints/housingCorporations/editHousingCorporationName'

interface Props {
  onRequestClose: Function
  cid: string | number
  onUpdateNeeded: Function
}

interface State {
  error?: string
  submitting: boolean
}

@observer
export default class EditNameModal extends Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context)

    this.state = {error: undefined, submitting: false}
  }

  onSubmit = (fields: {name: string}) => {
    this.setState({error: undefined, submitting: true})

    this.callEndpoint(editHousingCorporationName, {
      name: fields.name,
      cid: this.props.cid,
    }).then(
      () => {
        this.setState({submitting: false})
        this.props.onUpdateNeeded(fields.name)
        this.props.onRequestClose()
      },
      (error: any) => {
        this.setState(s => ({
          ...s,
          error: error.message || 'Unauthorized',
          submitting: false,
        }))
      },
    )
  }

  render() {
    const {props} = this
    let initialValues = undefined
    const data: {name?: string} = getSnapshot(
      // @ts-ignore
      this.store.housingCorporations.byId.get(props.cid),
    )
    initialValues = {
      name: data.name,
    }

    return (
      <GenericModal
        onHide={props.onRequestClose}
        css={{box: {container: css.box}}}
      >
        <Form onSubmit={this.onSubmit} initialValues={initialValues}>
          <TextInput.Field name="name" type="text" label="NAME" />
          <div className={css.bottom}>
            {this.state.error && (
              <div className={css.error}>Error occured: {this.state.error}</div>
            )}
            <GenericButton
              variant="bold"
              type="submit"
              disabled={this.state.submitting}
            >
              EDIT Name
            </GenericButton>
          </div>
        </Form>
      </GenericModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/housingCorporations/EditNameModal.tsx